import {
  EngagementSubmissionData,
  FullSubmissionFragment,
  Submission,
} from '@/generated/graphql';

export type SubmissionWithTypename<T extends EngagementSubmissionData> =
  Submission & {
    data: T & { __typename: string };
  };

export const createSubmissionTypeFilter =
  <SpecificSubmissionData extends EngagementSubmissionData>(typename: string) =>
  (
    s: FullSubmissionFragment,
  ): s is SubmissionWithTypename<SpecificSubmissionData> =>
    s.data.__typename === typename;
